module.exports = __webpack_public_path__ + "static/media/folder-icon.d25bcd3e.svg";